export class FilterMobile {

    init () {
        const button_menu = $( '.button-action' )
        button_menu.click( () => {
            return button_menu.toggleClass( 'active' )
        } )
    }

}


// WEBPACK FOOTER //
// ./scripts/components/filter-mobile.js